<template>
  <div class="pa-page pa-page-office">
    <MessageApp />

    <ContentLoadingSheild :isLoading="isLoading" />
    <PACharacterApplicationDetailModal />
  </div>
</template>

<script>
import LoginedPageMixins from '@/mixins/LoginedPageMixins'

import MessageApp                         from '@/components/Pages/Office/MessageApp/MessageApp.vue'
import ContentLoadingSheild               from '@/components/Pages/Office/ContentLoadingSheild/ContentLoadingSheild.vue'
import PACharacterApplicationDetailModal  from '@/components/Parts/PACharacterApplicationDetailModal/PACharacterApplicationDetailModal.vue'

import {GetCharacterMeta}                 from '@/graphql/queries/Character.graphql'
import {GetMessageRoom, GetMessageThread} from '@/graphql/queries/Message.graphql'

import {EnterMessageRoom}                 from '@/graphql/mutations/Character.graphql'

export default {
  mixins : [
    LoginedPageMixins
  ],

  components : {
    MessageApp,
    ContentLoadingSheild,
    PACharacterApplicationDetailModal
  },

  data(){
    return {
      isMountedOfficePage : false,

      isLoading           : false,

      roomName            : 'office',

      pageTitleSet        : {
        'office'  : '事務所',
        'sofa'    : '事務所内応接用ソファ'
      },
    };
  },

  computed : {
    isVisiblePageContent(){
      return this.$store.state.layouts.isVisiblePageContent;
    },

    shoudMesageRoomSofa(){
      return this.$store.state.message.shoudMesageRoomSofa;
    }
  },

  watch : {
    isVisiblePageContent : {
      handler(){
        this.checkCouldVisibleMessageApp();
      },
      immediate: true
    }
  },

  methods : {
    async checkCouldVisibleMessageApp(){
      if(this.isVisiblePageContent === false) return;
      if(this.isMountedOfficePage === false) return;
      
      this.isLoading = true;

      await this.UXWaiting(1000);

      await this.enterMessageRoom();

      await this.UXWaiting(500);

      this.isLoading = false;

      this.$store.dispatch({
        type  : 'message/updateIsEnterdMessageRoom',
        value : true
      });
    },

    executeEnterMessageRoom(roomName){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : EnterMessageRoom,
          variables : {
            roomName  : roomName
          },
          update    : (store, {data: {EnterMessageRoom: {messageRoom, messageThread, messageList, characterMetaList}}}) => {
            store.writeQuery({ query: GetMessageRoom, data : {
              messageRoom : messageRoom
            }});

            store.writeQuery({ query: GetMessageThread, data : {
              messageThread : messageThread
            }});

            if(messageThread.type !== 'auto_refresh'){
              this.$store.dispatch({
                type  : 'message/updatePreInsertMessages',
                data  : messageList
              });
            }

            if(characterMetaList !== null){
              store.writeQuery({ query: GetCharacterMeta, data : {
                characterMetaList : characterMetaList
              }});
            }
          }
        }).then(async (result) => {
          resolve(result);
        }).catch((error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    async enterMessageRoom(){
      if(this.shoudMesageRoomSofa === true){
        this.roomName = 'sofa';
      }

      const result = await this.executeEnterMessageRoom(this.roomName);

      // ページタイトルを再定義する
      await this.$store.dispatch({
        type  : 'updatePageTitle',
        title : this.pageTitleSet[this.roomName],
      });

      if(result !== false){
        // 入室したroomとthreadを記録します。
        await this.$store.dispatch({
          type  : 'message/updateRoomId',
          value : result.data.EnterMessageRoom.messageRoom.id,
        });

        await this.$store.dispatch({
          type  : 'message/updateThreadId',
          value : result.data.EnterMessageRoom.messageThread.id,
        });

        await this.$store.dispatch({
          type  : 'message/initializeRoomView'
        });
      }
    },

    leaveSofaRoom(){
      if(this.shoudMesageRoomSofa === false) return;

      this.$store.dispatch({
        type  : 'message/updateShouldMessageRoomSofa',
        value : false
      });
    }
  },

  async beforeDestroy(){
    this.leaveSofaRoom();
  },

  async mounted(){
    this.$on('mountedPage', () => {
      this.isMountedOfficePage = true;

      this.checkCouldVisibleMessageApp();
    });
    
    await this.initializePage({
      title : '事務所'
    });
  }
}
</script>